import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import {
  buildUrl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

export enum UNIT {
  DAY = 'Day',
  MONTH = 'Month',
  YEAR = 'Year',
}

interface OnboardingWarranties {
  diagnosticNeededForUnpackingWarranty: boolean;
  diagnosticNeededForLegalWarrantyOfConformity: boolean;
  isCommercialWithdrawalWarrantyAvailable: boolean;
  isCommercialWithdrawalWarrantyActivated: boolean;
  isExtensionWarrantyAvailable: boolean;
  isExtensionWarrantyActivated: boolean;
  isLegalWarrantyOfConformityAvailable: boolean;
  isLegalWarrantyOfConformityActivated: boolean;
  isOutOfWarrantyActivated: boolean;
  isProWithdrawalWarrantyAvailable: boolean;
  isProWithdrawalWarrantyActivated: boolean;
  isRefundWarrantyAvailable: boolean;
  isRefundWarrantyActivated: boolean;
  isReturnWarrantyAvailable: boolean;
  isReturnWarrantyActivated: boolean;
  isStockWarrantyAvailable: boolean;
  isStockWarrantyActivated: boolean;
  isSupplierLegalWarrantyOfConformityAvailable: boolean;
  isSupplierLegalWarrantyOfConformityActivated: boolean;
  isSupplierUnpackingWarrantyAvailable: boolean;
  isSupplierUnpackingWarrantyActivated: boolean;
  isSwapWarrantyAvailable: boolean;
  isSwapWarrantyActivated: boolean;
  isTransportWarrantyAvailable: boolean;
  isTransportWarrantyActivated: boolean;
  isUnpackingWarrantyAvailable: boolean;
  isUnpackingWarrantyActivated: boolean;
  isWithdrawalWarrantyAvailable: boolean;
  isWithdrawalWarrantyActivated: boolean;
  commercialWithdrawalWarrantyDuration: {
    unit: UNIT;
    value: string;
    isEmpty: boolean;
  };
  extensionWarrantyDuration: {
    unit: UNIT;
    value: string;
    isEmpty: boolean;
  };
  proWithdrawalWarrantyDuration: {
    unit: UNIT;
    value: string;
    isEmpty: boolean;
  };
  refundWarrantyDuration: {
    unit: UNIT;
    value: string;
    isEmpty: boolean;
  };
  returnWarrantyDuration: {
    unit: UNIT;
    value: string;
    isEmpty: boolean;
  };
  stockWarrantyDuration: {
    unit: UNIT;
    value: string;
    isEmpty: boolean;
  };
  legalWarrantyOfConformityDuration: {
    unit: UNIT;
    value: string;
    isEmpty: boolean;
  };
  supplierLegalWarrantyOfConformityDuration: {
    unit: UNIT;
    value: string;
    isEmpty: boolean;
  };
  supplierUnpackingWarrantyDuration: {
    unit: UNIT;
    value: string;
    isEmpty: boolean;
  };
  swapWarrantyDuration: {
    unit: UNIT;
    value: string;
    isEmpty: boolean;
  };
  transportWarrantyDuration: {
    unit: UNIT;
    value: string;
    isEmpty: boolean;
  };
  unpackingWarrantyDuration: {
    unit: UNIT;
    value: string;
    isEmpty: boolean;
  };
  withdrawalWarrantyDuration: {
    unit: UNIT;
    value: string;
    isEmpty: boolean;
  };
}

const ENDPOINT = `${APIConfiguration.import}onboardingWarranties`;

const getOnboardingWarrantiesQuery = async ({
  sellerId,
}: {
  sellerId: string;
}): Promise<BackResponse<OnboardingWarranties> | BackResponseFailure> => {
  try {
    const url = buildUrl(ENDPOINT, { sellerId });
    const response = await apiCall<BackResponse<OnboardingWarranties>>(url, {
      method: SUPPORTED_METHODS.GET,
    });

    return response;
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};

export default getOnboardingWarrantiesQuery;
